<template>
  <plugin-layout>
    <template v-if="plugin">
      <plugin-changelog :plugin-changelog="changelog" />
    </template>
  </plugin-layout>
</template>

<script setup lang="ts">
  import {useRoute} from 'vue-router';
  import PluginLayout from '../../components/PluginLayout.vue';
  import PluginChangelog from '../../components/PluginChangelog.vue';
  import {
    computed,
    definePageMeta,
    useAppStore,
    useAsyncData,
    usePluginStoreStore,
  } from '#imports';

  definePageMeta({
    layout: 'site',
  });

  const route = useRoute();

  const pluginStoreStore = usePluginStoreStore();
  const appStore = useAppStore();

  const plugin = computed(() => pluginStoreStore.plugin);
  const changelog = computed(() => pluginStoreStore.pluginChangelog);

  await useAsyncData(async () => {
    if (
      !(
        pluginStoreStore.plugin &&
        pluginStoreStore.plugin.handle === route.params.handle
      )
    ) {
      pluginStoreStore.updatePluginDetails(null);

      await pluginStoreStore
        .getPluginDetailsByHandle(route.params.handle)
        .then(() => {
          appStore.updatePageMeta({
            title: plugin.value.name,
            description: plugin.value.shortDescription,
          });
        })
        .catch((errorMsg) => {
          if (errorMsg === "Couldn't find plugin") {
            throw createError({statusCode: 404, message: errorMsg});
          } else {
            throw errorMsg;
          }
        });
    }

    if (
      pluginStoreStore.plugin &&
      pluginStoreStore.plugin.id &&
      !(
        pluginStoreStore.pluginChangelogPluginId &&
        pluginStoreStore.pluginChangelogPluginId ===
          pluginStoreStore.plugin.id &&
        pluginStoreStore.pluginChangelogCmsConstraint === appStore.cmsConstraint
      )
    ) {
      await pluginStoreStore.getPluginChangelog(pluginStoreStore.plugin.id);
    }
  });
</script>
